import React from 'react';
const items = [<>
    Logras generar contenido que por fin{' '}
    <strong className="font-bold" data-id="element-1">conecta y VENDE</strong>
  </>, <>
    Generas ingresos constantes que{' '}
    <strong className="font-bold" data-id="element-2">crecen mes a mes</strong>
  </>, <>
    Colaboras con cientos de marcas que{' '}
    <strong className="font-bold" data-id="element-3">
      te pagan y dan productos y servicios GRATIS
    </strong>
  </>];
export function AfterSection() {
  return <section className="px-8 py-14 bg-white flex flex-col items-center text-center w-full" data-id="element-4">
      <div className="max-w-7xl mx-auto" data-id="element-5">
        <h2 className="font-sans text-3xl md:text-5xl text-[#00c853] mb-10 font-medium" data-id="element-6">
          Después de acceder
        </h2>

        <ul className="w-full grid grid-cols-1 md:grid-cols-3 gap-8 text-left max-w-5xl mx-auto" data-id="element-7">
          {items.map((item, i) => <li key={i} className="flex items-start gap-3 bg-brand-lavenderLight/10 p-6 rounded-2xl shadow-sm border border-brand-lavenderLight/20" data-id="element-8">
              <span className="text-[#00c853] text-xl shrink-0 leading-tight font-bold" data-id="element-9">
                ✓
              </span>
              <span className="font-sans text-brand-navy text-[18px] md:text-xl leading-snug" data-id="element-10">
                {item}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}